import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { FunctionNodeView } from '../views/FunctionNode';
import { FunctionSettings } from '../settings/FunctionSettings';

export const functionDefinition: NodeDefinition<'function'> = {
  label: 'Function',
  showInPalette: true,
  paletteColor: 'bg-teal-100 border-teal-500 text-teal-700',
  miniMapColor: '#0f766e',
  defaultData: {
    label: 'Function',
    functionName: '',
    internalNodes: [],
    internalEdges: [],
  },
  view: FunctionNodeView,
  settings: FunctionSettings,
  run: async (node, ctx, log) => {
    if (node.data.internalNodes.length === 0) {
      log(`[Function] ${node.data.functionName || '名前なし'} は空です`);
      return { nextHandle: null };
    }
    log(`[Function] ${node.data.functionName} を実行`);
    const { runFlow } = await import('../../run');
    let outputReached = false;
    let outputValue: unknown;
    const internalContext = {
      ...ctx,
      captureFunctionOutput: (value: unknown) => {
        outputReached = true;
        outputValue = value;
      },
    };
    await runFlow(
      node.data.internalNodes,
      node.data.internalEdges,
      log,
      internalContext,
      undefined,
      ctx.signal,
      true,
    );
    if (!outputReached) {
      ctx.lastValue = undefined;
      log(`[Function] ${node.data.functionName || '名前なし'} のOutputまで到達しなかったため、メインフローを停止します`);
      return { nextHandle: null };
    }
    ctx.lastValue = outputValue;
  },
  help: {
    title: [t('Function（'), r('関数', 'かんすう'), t('）')],
    description: [
      t('いくつかの'),
      r('処理', 'しょり'),
      t('をひとつにまとめて、'),
      r('何度', 'なんど'),
      t('でも'),
      r('使', 'つか'),
      t('えるカードです。'),
    ],
  },
};